import { Fragment } from 'react';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { ThemeProps } from '@theme/base';
import { Component as ComponentContainer } from '@styles/layout';
import { GridComponent } from '@model/content';
import { getNestedComponents } from '@util/complex-components';
import { GridItem } from './GridItem';

const Container = styled(ComponentContainer)(({ theme }: ThemeProps) => ({
  padding: `0 ${theme.custom.spacing.medium / 2}px`,
  [ComponentContainer]: {
    padding: `0 ${theme.custom.spacing.medium}px`
  }
}));

export const GridContainer = ({ data }: GridComponent) => {
  const gridComponents = getNestedComponents(data);

  return (
    <Container>
      <Grid container spacing={0}>
        {gridComponents.map(({ title, components, ...props }, idx) => (
          <GridItem key={idx} {...props}>
            {components.map(({ renderable }, idxx) => (
              <Fragment key={idxx}>{renderable}</Fragment>
            ))}
          </GridItem>
        ))}
      </Grid>
    </Container>
  );
};
